import { render, staticRenderFns } from "./ContractConfirmation.vue?vue&type=template&id=ba4df4c6&scoped=true&"
import script from "./ContractConfirmation.vue?vue&type=script&lang=js&"
export * from "./ContractConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./ContractConfirmation.vue?vue&type=style&index=0&id=ba4df4c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4df4c6",
  null
  
)

export default component.exports